import { DiaryEntry } from "shared/types";

export const allEqualNumber = (
  key: "frames" | "strength" | "brood",
  arr: DiaryEntry[],
  first: DiaryEntry
) => {
  return arr.every((el) => el[key] === first[key]);
};
